import React from "react";
import PropTypes from "prop-types";

import CampaignCard from "../campaign-card";

import styles from "./styles.module.css";

const ProjectDetailCampaigns = ({ campaigns = [], projectName }) => {
  const currentDate = new Date();
  const activeCampaigns = campaigns
    .filter((campaign) => campaign.date && new Date(campaign.date) >= currentDate)
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  if (activeCampaigns.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{projectName} Kampanyaları</h2>
      <div className={styles.campaignBoxWrapper}>
        {activeCampaigns.map((campaign, index) => (
          <CampaignCard key={index} campaign={campaign} />
        ))}
      </div>
    </div>
  );
};

ProjectDetailCampaigns.propTypes = {
  campaigns: PropTypes.array,
  projectName: PropTypes.string,
};

export default ProjectDetailCampaigns;
